import { render, staticRenderFns } from "./of_dialog.vue?vue&type=template&id=26b6b695&scoped=true&"
import script from "./of_dialog.vue?vue&type=script&lang=js&"
export * from "./of_dialog.vue?vue&type=script&lang=js&"
import style0 from "./of_dialog.vue?vue&type=style&index=0&id=26b6b695&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b6b695",
  null
  
)

export default component.exports